<template>
  <div class="column is-9">
    <div class="is-border is-radius-large has-bg-white content content-guide">
      <div class="column is-border-bottom is-paddingless-bottom">
        <h1>{{title}}</h1>
        <div class="contenterror" v-html="content"></div>
        <br>
        <div class="gif" v-html="gif" v-if="$route.name === 'Home'"></div>
        <br>
        <div class="content2" v-html="content2"></div>
        <br>
      </div>
      <ul class="liste-themes-guide columns is-gapless is-multiline is-margin-bottom-large">
        <rubric-tile :key="rubric.id" :rubric="rubric" v-for="rubric in authorizedRubrics"></rubric-tile>
      </ul>
    </div>
  </div>
</template>

<script>
import showdown from 'showdown'
import { mapState, mapGetters } from 'vuex'
import RubricTile from '../components/RubricTile.vue'
// import { objectPage, objectRubric } from '../utils.js'
const contentful = require('contentful')
const converter = new showdown.Converter()

export default {
  name: 'Home',
  components: {
    RubricTile
  },
  data () {
    return {
      rubric: null,
      error: null,
      pages: [],
      title: null,
      content: null,
      gif: null,
      content2: null
    }
  },
  created () {
    this.gethomecontent()
  },
  computed: {
    ...mapState(['contentfullClient', 'rubrics', 'profil']), ...mapGetters(['authorizedRubrics'])
  },
  methods: {
    gethomecontent () {
      const client = contentful.createClient({
        space: '1gymb3e2piir',
        accessToken:
          'afd209d71174301d3271784f835a4b2583bf61cf6a3b9b2eba12ff61f0ef3c5d'
      })

      client.getEntries().then(response => {
        console.log(response.items)
        response.items.forEach(e => {
          if (e.sys.id === '3cZGwHDhvak6AawEK6GyUK') {
            this.title = e.fields.titre
            this.content = e.fields.abstract
            this.content = converter.makeHtml(this.content)
            this.gif = e.fields.content
            this.gif = converter.makeHtml(this.gif)
            this.content2 = e.fields.content2
          }
        })
      }).catch(console.error)
    }
  }
}
</script>
